import React from "react";
import "./Nav.scss";
import Triangle from "../../assets/homepage/trianglelogo.webp";
import CircleIcon from "../../assets/homepage/circlelogo.webp";
import { Link } from "react-router-dom";

const navList = [
  {
    name: "home",
    link: "/",
  },
  {
    name: "man",
    link: "/man",
  },
  {
    name: "nature",
    link: "/nature",
  },
  {
    name: "method",
    link: "/method",
  },
  {
    name: "hospitality",
    link: "earth-song",
    inPage: true,
    // subLink: [
    //   {
    //     name: "uru",
    //     link: "/uru",
    //   },
    //   {
    //     name: "kaavu",
    //     link: "/kaavu",
    //   },
    //   {
    //     name: "earth song",
    //     link: "/earth-song",
    //   },
    //   {
    //     name: "GCBC",
    //     link: "/gcbc",
    //   },
    // ],
  },
  {
    name: "commercial",
    link: "manchanda",
    inPage: true,
    // subLink: [
    //   {
    //     name: "taj biennale",
    //     link: "/taj-biennale",
    //   },
    //   {
    //     name: "commertial2",
    //     link: "",
    //   },
    // ],
  },
  {
    name: "competitions",
    link: "isle-of-the-immmortals",
    inPage: true,
  },
  // {
  //   name: "drafts",
  //   link: "/",
  // },
  {
    name: "find-us",
    link: "find",
    inPage: true,
  },
];

export default function Nav({
  isNavSticky,
  scrollTop
}) {
  const onScrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const onHnadleInPageNavBackToMain = (id) => {
    localStorage.setItem("selectedImageIndex", id);
  };

  return (
    <div
      className={`sticky-menu ${isNavSticky ? "fixed-nav-button" : "fixed-nav-hidden"}`}
    >
      <div className="nav-container">
        <div className="hover-area">
        <div className="ic-content">
          <div className="icon-wrapper">
          <img src={Triangle} alt="Triangle" className="triangle" />
          <img src={CircleIcon} alt="Circle" className="circle" />
          </div>

          <ul className="menu">
            {navList.map((list, index) => (
              <li>
                {list?.icon || list?.inPage ? (
                  <a
                    href="/"
                    onClick={() => onHnadleInPageNavBackToMain(list?.link)}
                  >
                    {list?.name} {list.subLink && <sup>+</sup>}
                  </a>
                ) : scrollTop && list.name === "home" ? (
                  <Link onClick={onScrollTop}>{list.name}</Link>
                ) : (
                  <Link to={`${list.link}`}>{list.name}</Link>
                )}
              </li>
            ))}
          </ul>
        </div>
        </div>
      </div>
    </div>
  );
}
